import { createContext } from 'react';

const ReduxStoreContext = createContext<any | null>(null);

export default ReduxStoreContext;
